export enum InvitationType {
  EMAIL = 'EMAIL',
  LINK = 'LINK',
}

export enum InvitationUserRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export interface IInvitationDetails {
  fullName: string
  email: string
  role: InvitationUserRole
}

export interface ICreateInvitationPayload {
  locationId: string
  groupId: string
  invitationType: InvitationType
  createdBy: string
  invitationDetails?: IInvitationDetails
}

export interface IInvitation {
  _id: string
  locationId: string
  groupId: string
  invitationType: InvitationType
  invitationDetails?: IInvitationDetails
  inviteeName?: string
  createdBy: string
  createdAt?: string
  updatedAt?: string
}

export interface IGokollabGenerateLinkResponse {
  referralLink: string
}

export interface IGokollabGenerateLeadPayload {
  name: string
  email: string
  groupId: string
  affiliateUrl: string
}

export interface InvitationFormData {
  fullName: string
  email: string
  adminPrivileges: boolean
}
